export function checkChildrenAndSetFocus(children, index) {
  if (children.length > index ) {
    children[index].focus();
  }
}

export function concateString(obj){
  let joinStr = "";
  let isAnyChar = false;
  obj.forEach(element => {
    if (element) {
      joinStr = joinStr + element;
      isAnyChar = true;
    } else {
      joinStr = joinStr + " ";
    }
  });

  return isAnyChar ? joinStr.replace(/\s+$/g, "") : "";
};

export function resizeCanvas(signatureRef) {
  var canvas = document.querySelector("canvas");
  var ratio = Math.max(window.devicePixelRatio || 1, 1);
  canvas.width = canvas.offsetWidth * ratio;
  canvas.height = canvas.offsetHeight * ratio;
  canvas.getContext("2d").scale(ratio, ratio);
  signatureRef.current.clear(); // otherwise isEmpty() might return incorrect value
};

export const NO_OF_BANK_COLUMN = 2;
export const NO_OF_BANK_ACCOUNT_NO_COLUMN = 7;
export const NO_OF_BANK_BRANCH_COLUMN = 4;
export const NO_OF_BANK_SUFFIX_COLUMN = 3;
export const NO_OF_BANK_ACCOUNT_HOLDER_COLUMN = 37;
export const NO_OF_BUSINESS_NAME_COLUMN = 74;
